import Dashboard from "@/pages/dashboard/dashboard-page.vue";

export default [
  {
    path: "/",
    component: () => import("@/pages/home/landing-page.vue"),
  },
  {
    path: "/dashboard",
    component: Dashboard,
    meta: {
      requiredLevel: ["admin", "verificator", "kepala"],
    },
  },
  {
    path: "/home",
    component: () => import("@/pages/home/landing-page.vue"),
  },
  {
    path: "/privacy-policy/",
    component: () => import("@/pages/home/Privasi.vue"),
  },
  {
    path: "/disclaimer/",
    component: () => import("@/pages/home/Disclaimer.vue"),
  },
  {
    path: "/syarat-penggunaan/",
    component: () => import("@/pages/home/Syarat.vue"),
  },
];
